// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_go-0";
export var animationContainer = "_go-1";
export var modalContent = "_go-2";
export var orderName = "_go-3";
export var refundOption = "_go-4";
export var refundOptionsContainer = "_go-5";